var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.detail)?_c('div',{staticClass:"detail"},[_c('div',{staticClass:"content"},[_c('ListItem',{attrs:{"data":_vm.detail,"origin":"detail"}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }